module.exports = __webpack_public_path__ + "static/media/recruiter-profile-edit.195c4437.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruiter-profile-edit.svg
// module id = 1143
// module chunks = 1